import React from 'react';
import MarketCard from './MarketCard';

function MarketBoard({
  divisions,
  selectedDivision,
  setSelectedDivision,
  teamFilter,
  setTeamFilter,
  markets,
  selectedMarket,
  setSelectedMarket,
  clearFilters,
}) {
  return (
    <section className="nxl-panel">
      <div className="nxl-section-heading">
        <div>
          <p className="nxl-kicker">MARKET BOARD</p>
          <h2>Scheduled matchups</h2>
          <p className="nxl-muted">{markets.length} scheduled markets shown</p>
        </div>

        <button className="nxl-small-button" onClick={clearFilters}>
          Clear
        </button>
      </div>

      <div className="nxl-filter-grid">
        <label className="nxl-field">
          <span>Division</span>
          <select
            value={selectedDivision}
            onChange={(e) => {
              setSelectedDivision(e.target.value);
              setSelectedMarket(null);
            }}
          >
            {divisions.map((division) => (
              <option key={division.division} value={division.division}>
                {division.division} ({division.openMarkets})
              </option>
            ))}
          </select>
        </label>

        <label className="nxl-field">
          <span>Team filter</span>
          <input
            value={teamFilter}
            onChange={(e) => setTeamFilter(e.target.value)}
            placeholder="Search team..."
          />
        </label>
      </div>

      <div className="nxl-market-legend">
        <span>Scheduled market</span>
        <span>Team A %</span>
        <span>Model Odds</span>
        <span>Team B %</span>
        <span>Model Odds</span>
      </div>

      <div className="nxl-market-list">
        {markets.map((market) => (
          <MarketCard
            key={market._id}
            market={market}
            selected={selectedMarket?._id === market._id}
            onSelect={setSelectedMarket}
          />
        ))}

        {!markets.length && (
          <p className="nxl-muted">No scheduled open markets match this filter.</p>
        )}
      </div>
    </section>
  );
}

export default MarketBoard;